var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("vue-simple-header", [
        _vm.post
          ? _c(
              "span",
              { attrs: { slot: "headerLabel" }, slot: "headerLabel" },
              [
                _vm._v("\n            Created in Group "),
                _c(
                  "strong",
                  [_c("simple-link", { attrs: { target: _vm.post.group } })],
                  1
                ),
                _vm._v("\n            by "),
                _c(
                  "strong",
                  [
                    _c("simple-link", {
                      attrs: { target: _vm.post.created_by },
                    }),
                  ],
                  1
                ),
                _vm._v(
                  " on\n            " +
                    _vm._s(_vm._f("gbdate")(_vm.post.date)) +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          { attrs: { slot: "panelRight" }, slot: "panelRight" },
          [
            _vm.visibleIcons.info
              ? _c("vue-folder-button", {
                  attrs: {
                    "icon-class": "fa-info",
                    target: { ..._vm.$route, name: "GroupPostDetailPageInfo" },
                    active: _vm.$route.meta.name === "info",
                    "is-router-link": true,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.post
              ? _c("like-with-popover", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.visibleIcons.like,
                      expression: "visibleIcons.like",
                    },
                  ],
                  attrs: {
                    "initial-entry": _vm.post,
                    "likes-entry-point": _vm.likesEntryPoint,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleIcons.comments
              ? _c(
                  "vue-folder-button",
                  {
                    attrs: {
                      "icon-class": "fa-comments-o",
                      text: _vm.commentsButtonText,
                      active: _vm.$route.meta.name === "comments",
                      target: {
                        ..._vm.$route,
                        name: "GroupPostDetailPageComments",
                      },
                      "is-router-link": true,
                    },
                  },
                  [
                    _c("span", {
                      attrs: { slot: "text" },
                      domProps: { innerHTML: _vm._s(_vm.commentsButtonText) },
                      slot: "text",
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleIcons.locations
              ? _c(
                  "vue-folder-button",
                  {
                    attrs: {
                      "icon-class": "fa-map-marker",
                      text: _vm.locationsButtonText,
                      tabindex: "0",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.editLocations.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("span", {
                      attrs: { slot: "text" },
                      domProps: { innerHTML: _vm._s(_vm.locationsButtonText) },
                      slot: "text",
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleIcons.viewEditMode
              ? _c(
                  "vue-folder-button",
                  {
                    attrs: {
                      "icon-class": _vm.editMode ? "fa-eye" : "fa-pencil",
                      "aria-label": "Edit Mode",
                      role: "button",
                      tabindex: "0",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.toggleEditMode.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("span", { attrs: { slot: "text" }, slot: "text" }, [
                      _vm._v(" "),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleIcons.remove
              ? _c("vue-folder-button", {
                  attrs: {
                    "icon-class": "fa-trash-o",
                    color: "red",
                    tabindex: "0",
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.removePost.apply(null, arguments)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleIcons.showMore
              ? _c("vue-folder-button", {
                  attrs: { "icon-class": "fa-ellipsis-h", tabindex: "0" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.expandButtons.apply(null, arguments)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleIcons.back
              ? _c("vue-folder-button", {
                  attrs: {
                    "icon-class": "fa-reply",
                    color: "blue",
                    tabindex: "0",
                    target: _vm.backUrl,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.initialized && !_vm.accessError
        ? _c(
            "div",
            {},
            [
              _c("router-view", {
                attrs: {
                  post: _vm.post,
                  "edit-mode": _vm.editMode,
                  "is-admin": _vm.accessLevel === _vm.ACCESS_LEVELS.EDIT,
                },
                on: {
                  onPostUpdate: _vm.onPostUpdate,
                  onCommentsCountChanged: _vm.onCommentsCountChanged,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.initialized && _vm.accessError
        ? _c("div", { staticClass: "alert alert-danger margin-15-top" }, [
            _c("strong", [_vm._v("Error")]),
            _vm._v(" Post not found or you do not have access to it\n    "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }